// src/pages/ShippingPolicy.jsx
import React from "react";
import PolicyLayout from "../components/common/PolicyLayout";
import "../components/common/styles/policyPages.css";

const ShippingPolicy = () => {
  return (
    <PolicyLayout
      title="Shipping Policy"
      subtitle="Information about order processing, delivery timelines, and shipping coverage.">
      <div className="policy-card">
        <section id="processing">
          <h3 className="policy-section-title">1. Order Processing</h3>
          <p className="policy-section-text">
            Orders are typically processed within 1–3 business days after
            successful payment confirmation. Orders placed on weekends or
            holidays may be processed on the next working day.
          </p>
        </section>

        <section id="delivery">
          <h3 className="policy-section-title">2. Delivery Timelines</h3>
          <p className="policy-section-text">
            Estimated delivery time may vary based on your location and courier
            partner:
          </p>
          <ul>
            <li>Metro cities: 3–7 business days</li>
            <li>Non-metro locations: 5–10 business days</li>
            <li>Remote or out-of-coverage areas: additional time may apply</li>
          </ul>
        </section>

        <section id="charges">
          <h3 className="policy-section-title">3. Shipping Charges</h3>
          <p className="policy-section-text">
            Shipping charges, if applicable, will be displayed at checkout
            before you confirm your order. From time to time, we may offer free
            shipping promotions.
          </p>
        </section>

        <section id="tracking">
          <h3 className="policy-section-title">4. Order Tracking</h3>
          <p className="policy-section-text">
            Once your order is shipped, you may receive an email or SMS with the
            tracking details. You can use this information to track your
            shipment on the courier partner&apos;s website.
          </p>
        </section>

        <section id="delays">
          <h3 className="policy-section-title">5. Delays & Force Majeure</h3>
          <p className="policy-section-text">
            While we strive to deliver orders within the estimated timelines,
            certain factors like weather, logistical issues, or unforeseen
            events may cause delays. In such cases, we will make reasonable
            efforts to keep you informed.
          </p>
        </section>

        <section id="incorrect">
          <h3 className="policy-section-title">6. Incorrect Address</h3>
          <p className="policy-section-text">
            Please ensure your delivery address and contact details are accurate
            at the time of placing the order. We are not responsible for delays
            or non-delivery due to incorrect or incomplete addresses.
          </p>
        </section>

        <div className="policy-meta">Last updated: 24/11/2025</div>
      </div>
    </PolicyLayout>
  );
};

export default ShippingPolicy;
